import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {  Home, AccountBox,ExitToApp  } from "@material-ui/icons/";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";

import HomeView from "views/Home/Home";
import UserProfile from "views/UserProfile/UserProfile";
import LogoutPage from "views/UserProfile/LogoutPage.js";
import MyCustomForm from "views/Home/MyCustomForm";
import QueueTwin from "views/QueueTwin/QueueTwin";


let ps;

const routes = [
    {
      name: "Custom FloorMap",
      icon: Home,
      component: QueueTwin,
      layout: "/home",
      path: "/custom-floormap",
      hidden: true,
    },
    {
      name: "Queue Digital Twin",
      icon: Home,
      component: QueueTwin,
      layout: "/home",
      path: "/queue-twin",
      hidden: true,
    },
    {
      name: "หน้าหลัก",
      icon: Home,
      component: HomeView,
      layout: "/home",
      path: "/index",
    },
    {
      name: "จัดการข้อมูลส่วนตัว2",
      icon: AccountBox,
      component: UserProfile,
      layout: "/home",
      path: "/profile/:code",
      hidden: true
    },    
    {
      name: "จัดการข้อมูลส่วนตัว",
      icon: AccountBox,
      component: UserProfile,
      layout: "/home",
      path: "/profile",
    },      
    {
      name: "ออกจากระบบ",
      icon: ExitToApp,
      component: LogoutPage,
      layout: "/auth",
      path: "/logout",
    },
  /*
,
    {
      name: "Test2",
      icon: Build,
      component: Request,
      layout: "/meeting",
      path: "/request",
    },
    */
   
];

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
     
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      
      return null;
    })}
    <Route
      path="/home/profile/:code"
      component={UserProfile}
      key={routes.length+1}
    />
    <Route path="/home/mycustomform" render={(props) => <MyCustomForm {...props} />} />
    <Redirect from="/" to="/home/index" />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function Meeting({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"หน้าหลัก"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        {/* <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        /> */}
      </div>
    </div>
  );
}
